import { DayPicker } from 'react-day-picker'
import type { DateRange } from 'react-day-picker'
import 'react-day-picker/style.css'
import { format } from 'date-fns'
import { nl } from 'date-fns/locale'
import { Calendar as CalendarIcon } from 'lucide-react'
import { cn } from '@/lib/utils'
import { Button } from '@/components/ui/button'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'

interface RangeDatePickerProps {
  value: DateRange | undefined
  onChange: (range: DateRange | undefined) => void
  placeholder?: string
  className?: string
}

export default function RangeDayPicker({
  value,
  onChange,
  placeholder = 'Selecteer periode',
  className,
}: RangeDatePickerProps) {
  const display =
    value?.from && value?.to
      ? `${format(value.from, 'dd/MM/yyyy')} — ${format(value.to, 'dd/MM/yyyy')}`
      : placeholder

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          className={cn(
            'w-full justify-start text-left font-normal h-12',
            !value && 'text-muted-foreground',
            className
          )}
          type="button"
        >
          <CalendarIcon className="mr-2 h-4 w-4" />
          {display}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <div className="p-3">
          <DayPicker
            mode="range"
            selected={value}
            onSelect={onChange}
            numberOfMonths={1}
            required={false}
            max={3}
            locale={nl}
          />
        </div>
      </PopoverContent>
    </Popover>
  )
}
